import type { OrderCategory, OrderDto, SizeClass } from '@posilka/shared';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { UploadedPhoto } from '@/components/PhotoPicker';
import type { PickedPlace } from '@/features/map/LocationPicker';

export interface OrderDraft {
  step: number;
  fromCityId?: string;
  toCityId?: string;
  pickup?: PickedPlace;
  date?: string;
  timeFrom: string;
  timeTo: string;
  dropoff?: PickedPlace;
  recipientName: string;
  /** 9 raqam, +998 siz. */
  recipientPhone: string;
  category?: OrderCategory;
  sizeClass?: SizeClass;
  description: string;
  photos: UploadedPhoto[];
  price?: number;
  /** Tanlangan safar — buyurtma avval o'sha shafyorga taklif. */
  tripId?: string;
  confirmed: boolean;
}

const initial: OrderDraft = {
  step: 0,
  timeFrom: '09:00',
  timeTo: '13:00',
  recipientName: '',
  recipientPhone: '',
  description: '',
  photos: [],
  confirmed: false,
};

/**
 * "Yana yuborish": oldingi buyurtmadan yo'nalish, manzillar, qabul qiluvchi, toifa, o'lcham va izoh.
 * Sana/vaqt, rasmlar va narx ko'chirilmaydi (yangi buyurtma — yangi rasm va joriy narx).
 */
export function draftFromOrder(o: OrderDto): OrderDraft {
  const place = (p: OrderDto['pickup']) =>
    p.address ? { address: p.address, lat: p.lat, lng: p.lng } : undefined;
  return {
    ...initial,
    fromCityId: o.fromCity.id,
    toCityId: o.toCity.id,
    pickup: place(o.pickup),
    dropoff: place(o.dropoff),
    recipientName: o.recipient?.name ?? '',
    recipientPhone: o.recipient?.phone.replace(/^\+998/, '') ?? '',
    category: o.category,
    sizeClass: o.sizeClass,
    description: o.description,
  };
}

interface DraftStore extends OrderDraft {
  set: (patch: Partial<OrderDraft>) => void;
  reset: () => void;
}

/** Forma qoralamasi: Mini App yopilib-ochilsa ham saqlanadi (sessionStorage). */
export const useDraft = create<DraftStore>()(
  persist(
    (set) => ({
      ...initial,
      set: (patch) => set(patch),
      reset: () => set(initial),
    }),
    {
      name: 'posilka-order-draft',
      storage: createJSONStorage(() => sessionStorage),
      // Object URL'lar qayta yuklangandan keyin yaroqsiz.
      partialize: ({ set: _s, reset: _r, ...d }) => ({
        ...d,
        photos: d.photos.map(({ key }) => ({ key })),
      }),
    },
  ),
);
